import { render } from "./PerfilEstudiante.vue?vue&type=template&id=6c30b484"
import script from "./PerfilEstudiante.vue?vue&type=script&lang=js"
export * from "./PerfilEstudiante.vue?vue&type=script&lang=js"

import exportComponent from "/home/computacionucat/ucat-evaluacion-desempeno-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__